module.exports = __webpack_public_path__ + "static/media/ImporterFeature6.e0bbfc53.svg";